<template>
  <div>
    <el-dialog :title="title" @close="close" width="30%" :visible.sync="dialogFormVisible">
      <avue-form ref="form" v-model="form" :rules="rules" :option="option">
        <template slot-scope="scope" slot="menuForm">
          <div style="text-align: right;">
            <el-button class="filter-item filter-item1" size="mini" icon="el-icon-circle-close-outline" @click="dialogFormVisible = false">取消
            </el-button>
            <el-button class="filter-item filter-item1" size="mini" type="primary" icon="el-icon-circle-close-outline"
              @click="editbtn">确定
            </el-button>
          </div>
        </template>
      </avue-form>
    </el-dialog>
  </div>
</template>
<script>
  import {
    getpersonnel,
    insertOrUpdateUser
  } from '@/api/admin/workerUser'
  import {
    dealElement
  } from '@/util/util'
  import {
    getImgLink
  } from '@/config/env'
  import {
    phone,
    validatePass
  } from '@/util/Format'
  import {
    mapGetters
  } from 'vuex'
  import {
    dateOnce
  } from '@/util/dateT'
  import {
    objKeySort
  } from '@/util/ajaxsign'
  export default {
    data() {
      return {
        title: '',
        userId: '',
        dialogFormVisible: false,
        coldderail: true,
        dictionarylist: [],
        avatar: '',
        department: '',
        name: '',
        phone: '',
        status: '',
        companyAuthStatus: '',
        form: {},
        rules: {},
        option: {
          emptyBtn: false,
          submitBtn: false,
          submitText: '确定',
          column: [{
            label: "手机号",
            prop: "phone",
            visdiplay: true,
            span: 24,
            maxlength: 11,
            rules: [{
              validator: phone,
              trigger: 'blur'
            }]
          }, {
            label: "员工密码",
            prop: "password",
            visdiplay: true,
            type: 'password',
            span: 24,
            rules: [{
              validator: validatePass,
              trigger: 'blur'
            }]
          }, {
            label: "员工姓名",
            prop: "userName",
            disabled: false,
            span: 24,
            maxlength: 5,
          }, {
            label: "所属部门",
            prop: "deptId",
            type: "tree",
            span: 24,
            dicUrl: '/dept/tree',
            dicMethod: "post",
            maxlength: 10,
            dicQuery: objKeySort({}),
            props: {
              label: 'name',
              value: 'id'
            }
          }, {
            label: "管理角色",
            prop: "isAdminRole",
            type: "switch",
            dicData:[{
              label: '是',
              value: 1
            },{
              label: '否',
              value: 0
            }, ],
            disabled: false,
            span: 24,
            maxlength: 5
          }]
        },
      }
    },
    created() {},
    mounted() {},
    methods: {
      //刷新列表操作
      refresh() {
        this.getCompanyInfo();
        this.$emit('refresh');
      },
      //设置展示
      setsataus(userid, title) {
        this.dialogFormVisible = true;
        this.title = title;
        this.userId = userid;
        if (title == "编辑员工") {
          this.getemployee();
          this.option.column[1].visdiplay = false;
          this.option.column[0].disabled = true;
        } else {
          this.option.column[1].visdiplay = true;
          this.option.column[0].disabled = false;
        }
      },

      //项目详情数据请求
      getemployee() {
        getpersonnel(objKeySort({
          userId: this.userId
        })).then(response => {
          this.form.deptId = response.data.data.deptId ? response.data.data.deptId : undefined;
          this.form.userName = response.data.data.name ? response.data.data.name : undefined;
          this.form.phone = response.data.data.phone ? response.data.data.phone : undefined;
          this.form.isAdminRole = response.data.data.isAdminRole?response.data.data.isAdminRole:0;
          this.userId = response.data.data.id;
        })
      },

      //默认时间
      settime(data) {
        return dateOnce(data)
      },

      //取消回调
      close() {
        this.$refs.form.resetForm();
        this.dialogFormVisible = false;
      },

      //处理编辑员工操作
      editbtn() {
        console.log(123456)
        if (this.title == "添加员工") {
          console.log(this.form)
          this.addemployee();
        } else {
          this.editemployee();
        }
      },

      //添加员工
      addemployee() {
        let that=this
        let _form=that.$refs.form.form
          if(!_form.userName){
           that.$notify({
              title: '温馨提示',
              message: '员工姓名不能为空',
              type: 'warning'
            });
            return
          }
          if(!_form.phone){
            that.$notify({
               title: '温馨提示',
               message: '员工手机号不能为空',
               type: 'warning'
             });
             return
          }
          if(!_form.password){
            that.$notify({
               title: '温馨提示',
               message: '员工密码不能为空',
               type: 'warning'
             });
             return
          }
          if(!_form.isAdminRole){
            that.form.isAdminRole=0;
          }
          if (_form.userName&&_form.phone&&_form.password) {
            insertOrUpdateUser(objKeySort(that.form)).then(response => {
              that.$message({
                message: response.data.msg,
                type: response.data.msg == "操作成功" ? 'success' : 'warning'
              });
              that.$emit('refresh');
              that.close();
            })
          }
      },
      //编辑员工
      editemployee() {
        this.$refs.form.validate(vaild => {
          if (vaild) {
            this.form.userId = this.userId;
            if(!this.form.isAdminRole){
              this.form.isAdminRole=0;
            }
            insertOrUpdateUser(objKeySort(dealElement(this.form))).then(response => {
              this.$emit('refresh');
              this.close();
            })
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .container {
    min-width: 800px;
    max-width: 900px;
  }

  .form_layout_items {
    display: flex
  }

  .select_option {
    position: absolute;
    z-index: 22;
    width: 150px !important;
    right: 0;
    top: 0;
  }

  .el-table ::v-deep .el-table__row:nth-child(even) {
    background-color: #F6F9FF !important;
  }

  .form_layout_item {
    width: 50%;
    border: 1px solid #fff;
    height: 80px;
  }
</style>
